import { Link } from "react-router-dom";
import { navLinks, profile } from "../../data/profile";
import SocialLinks from "../SocialLinks/SocialLinks";
import "./Footer.scss";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="site-footer__top">
          <div className="site-footer__intro">
            <Link to="/" className="brand" aria-label={`${profile.name}, home`}>
              <span className="brand__mark" aria-hidden="true">
                GR
              </span>
              <span className="brand__name">{profile.name}</span>
            </Link>
            <p className="site-footer__tagline">
              {profile.role} building React Native apps and Node.js backends from{" "}
              {profile.location}.
            </p>
            <SocialLinks />
          </div>

          <nav aria-label="Footer" className="site-footer__nav">
            <h2 className="site-footer__heading">Pages</h2>
            <ul>
              {navLinks.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="site-footer__nav">
            <h2 className="site-footer__heading">Get in touch</h2>
            <ul>
              <li>
                <a href={`mailto:${profile.email}`}>{profile.email}</a>
              </li>
              <li>
                <a href={profile.phoneHref}>{profile.phone}</a>
              </li>
              <li>
                <a href={profile.resumeUrl} target="_blank" rel="noopener noreferrer">
                  Resume (PDF)
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="site-footer__bottom">
          <p>
            © {year} {profile.name}. All rights reserved.
          </p>
          <p>{profile.location}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
